import { render, staticRenderFns } from "./NewClient.vue?vue&type=template&id=03828dc3&scoped=true&"
import script from "./NewClient.vue?vue&type=script&lang=js&"
export * from "./NewClient.vue?vue&type=script&lang=js&"
import style0 from "./NewClient.vue?vue&type=style&index=0&id=03828dc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03828dc3",
  null
  
)

export default component.exports